import { call, put, takeEvery, all, fork } from 'redux-saga/effects';

import {
  GET_SUPPLIESLIST,
  GET_SUPPLIES_LOOKUP,
  CREATE_SUPPLIESLIST,
  UPDATE_SUPPLIESLIST,
  DELETE_SUPPLIESLIST,
} from './actionType';

import { ApiResponseSuccess, ApiResponseError } from './action';

import {
  getSuppliesList as getSupplieList,
  createSuppliesList as creatSupplieList,
  updateSuppliesList as updtaeSupplieList,
  deleteSuppliesList as deleteSupplieList,
  getSuppliersLookup as getLookupSuppliers,
} from '../../helpers/backend_helper';
import { notifyError, notifySuccess } from '../../components/notify';

function* getSuppliesList(data) {
  try {
    const response = yield call(getSupplieList, data.payload.id);
    yield put(ApiResponseSuccess(GET_SUPPLIESLIST, response));
  } catch (error) {
    yield put(ApiResponseError(GET_SUPPLIESLIST, error));
  }
}

function* getSuppliersLookup() {
  try {
    const response = yield call(getLookupSuppliers);
    yield put(ApiResponseSuccess(GET_SUPPLIES_LOOKUP, response));
  } catch (error) {
    yield put(ApiResponseError(GET_SUPPLIES_LOOKUP, error));
  }
}

function* createSuppliesList(data) {
  try {
    const response = yield call(creatSupplieList, data.payload);
    yield put(ApiResponseSuccess(CREATE_SUPPLIESLIST, response));
    notifySuccess('Credencial criada com sucesso!');
  } catch (error) {
    yield put(ApiResponseError(CREATE_SUPPLIESLIST, error));
    notifyError('Erro ao criar Fornecedor!');
  }
}

function* updateSuppliesList(data) {
  try {
    const response = yield call(updtaeSupplieList, data.payload);
    yield put(ApiResponseSuccess(UPDATE_SUPPLIESLIST, response));
    notifySuccess('Credencial atualizada com sucesso!');
  } catch (error) {
    yield put(ApiResponseError(UPDATE_SUPPLIESLIST, error));
    notifyError('Erro ao atualizar Fornecedor!');
  }
}

function* deleteSuppliesList(data) {
  try {
    const response = yield call(deleteSupplieList, data.payload.id);
    yield put(ApiResponseSuccess(DELETE_SUPPLIESLIST, response));
    notifySuccess('Credencial deletada com sucesso!');
  } catch (error) {
    yield put(ApiResponseError(DELETE_SUPPLIESLIST, error));
    notifyError('Erro ao deletar Fornecedor!');
  }
}

export function* watchGetSuppliesList() {
  yield takeEvery(GET_SUPPLIESLIST, getSuppliesList);
}

export function* watchGetSuppliesLookup() {
  yield takeEvery(GET_SUPPLIES_LOOKUP, getSuppliersLookup);
}

export function* watchCreateSuppliesList() {
  yield takeEvery(CREATE_SUPPLIESLIST, createSuppliesList);
}

export function* watchUpdateSuppliesList() {
  yield takeEvery(UPDATE_SUPPLIESLIST, updateSuppliesList);
}

export function* watchDeleteSuppliesList() {
  yield takeEvery(DELETE_SUPPLIESLIST, deleteSuppliesList);
}

function* SuppliesListSaga() {
  yield all([fork(watchGetSuppliesList)]);
  yield all([fork(watchGetSuppliesLookup)]);
  yield all([fork(watchCreateSuppliesList)]);
  yield all([fork(watchUpdateSuppliesList)]);
  yield all([fork(watchDeleteSuppliesList)]);
}

export default SuppliesListSaga;
